(function () {
    'use strict';

    angular.module('app').factory('handleException', handleException);
    handleException.$inject = ["$log"];

    function handleException($log) {
        return {
            log: function(error) {
                $log.error(error.status + ' : ' + error.statusText);

            }
        };
    }
})();